export default {
    base_page: {
        title: 'Хочаце такі ж модуль браніравання для вашай нерухомасці?',
        description: 'Гэты модуль браніравання створаны з дапамогай сэрвісу RealtyCalendar',
        button: 'Даведацца больш',
    },
    common: {
        months: [
            'студзеня',
            'лютага',
            'сакавіка',
            'красавіка',
            'мая',
            'чэрвеня',
            'ліпеня',
            'жніўня',
            'верасня',
            'кастрычніка',
            'лістапада',
            'снежня',
        ],
        back: 'Назад',
        book: 'Забраніраваць',
        more: 'Падрабязней',
        from: 'ад',
        find: 'Знайсці',
        reset: 'Скінуць',
        apply: 'Ужыць',
        cancel: 'Скасаваць',
        close: 'Закрыць',
        print: 'Раздрукаваць',
        change: 'Змяніць',
        arrival: 'Заезд',
        by_list: 'Спісам',
        by_map: 'На карце',
        download_confirmation: 'Спампаваць пацвярджэнне браніравання',
        guests: {
            adults: 'Дарослыя',
            child: 'Дзіця:',
            add_child: 'Дадаць дзіця',
            guest: '{count} гасцей | {count} госць | {count} госць | {count} госці | {count} гасцей',
            child_count: '{count} дзяцей | {count} дзіця | {count} дзіця | {count} дзеці | {count} дзяцей',
            list: 'Спіс гасцей',
        },
        confirm_close: {
            title: 'Вы сапраўды хочаце закрыць акно?',
            text: 'Пры закрыцці будуць страчаны вашы даныя па браніраванні.',
        },
        meta: {
            title: 'Модуль браніравання',
            description: 'Ваша ідэальнае жыллё чакае вас. Забраніруйце за некалькі секунд!',
        },
        select_date: 'Выбраць дату',
        departure: 'Выезд',
        refresh: 'Абнавіць',
        year: '{count} гадоў | {count} год | {count} гады | {count} гады | {count} гадоў',
    },
    calendar: {
        check_in: 'Заезд',
        check_out: 'Выезд',
        check_in_check_out: 'Заезд–Выезд',
        select_date: 'Выберыце дату',
        select_check_in_date: 'Выберыце дату заезду',
        select_check_out_date: 'Выберыце дату выезду',
        departure_only_hint: 'магчымы толькі выезд',
        check_in_date_with_time: 'Заезд {date} - Выберыце дату выезду',
        check_in_check_out_dates: 'Заезд {checkIn} - выезд {checkOut}',
        check_in_date: 'Дата заезду',
        check_out_date: 'Дата выезду',
        booking_min_days: 'Мінімальнае браніраванне: {days} дні',
        discount_days: 'зніжка ад {days} дзён',
        while_staying: 'пры пражыванні',
    },
    basket: {
        title: 'Браніраванне',
        arrival_time: 'Час заезду',
        departure_time: 'Час выезду',
        select_time: 'Выберыце час',
        booking_params: 'Параметры браніравання',
        form: {
            first_name: 'Імя',
            last_name: 'Прозвішча',
            phone: 'Тэлефон',
            additional_phone: 'Дад. тэлефон (неабавязкова)',
            email: 'Email',
            email_optional: 'Email (неабавязкова)',
            wishes: 'Вашы пажаданні (неабавязкова)',
            enter_name: 'Увядзіце імя',
            enter_last_name: 'Увядзіце прозвішча',
            enter_phone: 'Увядзіце нумар',
            enter_email: 'Увядзіце email',
            placeholder_wishes: 'Пакіньце пажаданні для ўладальніка',
        },
        price: {
            cost: 'Кошт',
            select_tariff: 'Выберыце тарыф',
            stay_amount: 'Сума {period}',
            total: 'Усяго',
            long_stay_discount: 'Зніжка за доўгае пражыванне',
            rate_discount: 'Зніжка па тарыфе',
            promo_code_discount: 'Зніжка па промакодзе',
            processing_fee: 'Апрацоўка плацяжу',
            payment_system_fee: 'Камісія плацежнай сістэмы',
            service_fee: 'Сэрвісны збор',
            service_fee_tooltip: 'Сродкі спачатку залічваюцца на рахунак плацежнай сістэмы, а потым пералічваюцца ўладальніку пасля вашага выезду. Сэрвісны збор забяспечвае бяспечнае правядзенне здзелкі і абарону вашых інтарэсаў як госця.',
            pay_now: 'Сума да аплаты цяпер',
            pay_later: 'Аплаціць пры заездзе',
            pay_later_tooltip: 'Уладальнік аб’екта загадзя звяжацца з вамі, каб патлумачыць, як унесці аплату. Некаторыя ўладальнікі таксама могуць папрасіць унесці заклад.',
            select_dates_and_guests: 'Выберыце даты заезду, выезду і колькасць гасцей',
            payment_method: {
                title: 'Спосаб аплаты',
                sbp: 'СБП',
                card: 'Банкаўская картка',
            },
        },
        agreement: {
            text: `Я даю {consentLink}згоду на апрацоўку персанальных даных{/consentLink},
        і пацвярджаю азнаямленне з {bookingRulesLink}Правіламі браніравання{/bookingRulesLink},
        умовамі аферты {safeTransactionsLink}Пераклад без рызыкі{/safeTransactionsLink}
        і {privacyLink}Палітыкай у адносінах да апрацоўкі персанальных даных{/privacyLink}.`,
            consent_text: `Я даю {consentLink}згоду на апрацоўку персанальных даных{/consentLink}.`,
            rules_text: `Пацвярджаю азнаямленне з {bookingRulesLink}Правіламі браніравання{/bookingRulesLink}, умовамі аферты {safeTransactionsLink}Пераклад без рызыкі{/safeTransactionsLink} і {privacyLink}Палітыкай у адносінах да апрацоўкі персанальных даных{/privacyLink}.`,
            safe_transactions: 'Перавод без рызыкі',
            privacy_policy: 'Палітыка апрацоўкі персанальных даных',
            accommodation_rules: 'Правілы пражывання',
            booking_rules: 'Правілы браніравання',
            foreign: {
                text: `Я згаджаюся з {agreementLink}умовамі браніравання, правіламі пражывання і палітыкай прыватнасці{/agreementLink}.`,
            },
        },
        validation: {
            enter_check_in_date: 'Выберыце дату заезду',
            enter_check_out_date: 'Выберыце дату выезду',
            enter_name_required: 'Увядзіце імя',
            name_min_length: 'Імя павінна ўтрымліваць мінімум 2 сімвалы',
            name_letters_only: 'Імя можа ўтрымліваць толькі літары',
            enter_last_name_required: 'Увядзіце прозвішча',
            last_name_min_length: 'Прозвішча павінна ўтрымліваць мінімум 2 сімвалы',
            last_name_letters_only: 'Прозвішча можа ўтрымліваць толькі літары',
            enter_phone_required: 'Увядзіце нумар тэлефона',
            phone_invalid: 'Увядзіце карэктны нумар тэлефона',
            enter_email_required: 'Увядзіце email',
            email_invalid: 'Увядзіце карэктны email',
        },
        payment: {
            timer_text: 'Унясіце перадаплату як мага хутчэй, пакуль жыллё вольнае. Вас перанакіруе на сэрвіс аплаты. Пасля аплаты аб’ект будзе забраніраваны за вамі.',
        },
        promocode: {
            enter_promocode: 'Увесці промакод',
            promocode: 'Промакод',
            enter_code: 'Увядзіце промакод',
            discount: 'Зніжка па промакодзе',
        },
    },
    hotel: {
        details: {
            description: 'Апісанне',
            amenities: 'Якія зручнасці вас чакаюць',
            show_all_amenities: 'Паказаць усе зручнасці: {count}',
            address: 'Адрас',
            classification_certificate: 'Пасведчанне аб прысваенні катэгорыі № {number}',
        },
        apartment: {
            room: '{count} пакояў | {count} пакой | {count} пакой | {count} пакоі | {count} пакояў',
            bed: '{count} спальных месцаў | {count} спальнае месца | {count} спальнае месца | {count} спальныя месцы | {count} спальных месцаў',
            available_dates: 'Даступныя даты',
            date_range_sold_out: 'На {range} аб’ект распрададзены.',
            select_free_dates: 'Выберыце вольныя даты ў календары.',
            booking_available_from: 'браніраванне даступна ад {minStay} сутак.',
            date_range_on: 'На {range}',
            rooms: 'Пакояў',
            area: 'Плошча',
            floor: 'Паверх',
            beds: 'Спальных месцаў',
            day_off: 'за {count} сутак | за {count} суткі | за {count} сутак | за {count} сутак | за {count} сутак',
            night_off: 'за {count} нач | за {count} ноч | за {count} ночы | за {count} нач | за {count} нач',
        },
        map: {
            found: 'Знойдзена',
            scroll: 'Пракруціце, каб паглядзець усе',
            variant: '{count} варыянтаў | {count} варыянт | {count} варыянт | {count} варыянты | {count} варыянтаў',
            metro: 'Метро',
        },
    },
    room_attributes: {
        washing_machine: 'Пральная машына',
        wi_fi: 'Інтэрнэт Wi-Fi',
        tv: 'Тэлевізар',
        air_conditioning: 'Кандыцыянер',
        refrigerator: 'Халадзільнік',
        dishwasher: 'Посудмыйная машына',
        music_center: 'Музычны цэнтр',
        microwave: 'Мікрахвалевая печ',
        iron: 'Прас і прасавальная дошка',
        concierge: 'Кансьерж',
        parking: 'Паркоўка',
        safe: 'Сейф',
        waterheater: 'Воданагравальнік',
        bathroom: 'Лазневыя прыналежнасці',
        animals: 'Можна з жывёламі',
        smoke: 'Можна курыць',
        balcony: 'Балкон',
        elevator: 'Ліфт',
        romantic: 'Для рамантычных сустрэч',
        jacuzzi: 'З джакузі',
        kids: 'Можна з дзецьмі',
        party: 'Для мерапрыемстваў',
        telephone: 'Тэлефон',
        stove: 'Кухонная пліта',
        cabletv: 'Кабельнае тэлебачанне',
        pool: 'Басейн',
        seafront: 'Першая берагавая лінія',
        playground: 'Дзіцячая пляцоўка',
        sauna: 'Сауна, лазня',
        transfer: 'Трансфер',
        seaview: 'Від на мора',
        mountainview: 'Від на горы',
        crib: 'Дзіцячая ложачак',
    },
    error: {
        map_loading_failed: 'Не ўдалося загрузіць усе даступныя аб’екты.',
        no_rooms: 'Няма вольных месцаў',
        no_rooms_text: 'На выбраныя даты не знойдзена вольных варыянтаў. Калі ласка, звяжыцеся з намі — у нас заўсёды ёсць што прапанаваць!',
        occurred: 'Адбылася памылка',
        booking_error_text: 'Нешта пайшло не так, звяжыцеся з намі:',
        connect_error_text: 'Падчас пошуку знікла сувязь з серверам, паўтарыце запыт',
        return_to_apartments: 'Вярнуцца да аб’ектаў',
        validation: 'Памылка валідацыі',
        not_found: 'Нешта пайшло не так, гэтай старонкі не існуе',
    },
    success: {
        booked: 'Забраніравана',
        thanks: 'Дзякуй! Вы паспяхова забраніравалі {address}',
        booking_info: 'Інфармацыя пра браніраванне',
        check_in: 'Заезд',
        check_out: 'Выезд',
        amount: 'Сума',
        prepaid: 'Унесена перадаплата',
        pay_on_arrival: 'Даплаціць на месцы',
        message_for_you: 'Паведамленне для вас',
        check_in_date_time: '{date}, з {timeStart} да {timeEnd}',
        check_out_date_time: '{date}, з {timeStart} да {timeEnd}',
        notifications: {
            title: 'Бясплатныя апавяшчэнні',
            description: 'Паведамім важнае пра ваша браніраванне',
            connect_button: 'Падключыць у Telegram',
        },
    },
    days: {
        day: '{count} дзён | {count} дзень | {count} дзень | {count} дні | {count} дзён',
    },
    loader: {
        loading: 'Ідзе загрузка...',
        searching: 'Шукаем даступныя прапановы...',
        checking: 'Правяраем цэны...',
    },
    rules: {
        privacy_policy: 'Палітыка апрацоўкі персанальных даных',
        accommodation_rules: 'Правілы пражывання',
        booking_rules: 'Правілы браніравання',
        consent: {
            title: 'Згода на апрацоўку персанальных даных',
            title2: 'Палітыка ў галіне апрацоўкі персанальных даных',
            text: `Настоящим, я, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, предоставляя данные о себе, даю согласие {legalName}, ИНН {inn}, (далее – Оператор) на обработку следующих моих персональных данных, указанных мною при бронировании Проживания на сайте https://homereserve.ru или иным способом, с целью оформления и исполнения бронирования Проживания, в том числе оказания дополнительных услуг в Средстве/Объекте размещения Оператора: {<br>}

                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, 
                    страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол;  {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}

                    Для достижения указанной цели Оператор может осуществлять любые действия (операции) или совокупности действий (операций), 
                    совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, указанными выше,
                    включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, 
                    передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных. {<br>}

                    Я даю согласие Оператору на передачу (предоставление, доступ) персональных данных, указанных выше, в адрес следующего юридического лица, действующего по поручению Оператора: ООО «Апартмент системс», ИНН 7729748911 ОГРН 1137746760381, юридический адрес: 119607, г. Москва, ул. Раменки, д. 25 к. 3, кв. 668, а также иным третьим лицам через ООО «Апартмент системс» (для целей интеграции с системами бронирования, CRM-системами) в целях автоматизации бизнес-процессов, централизованного хранения и управления данными, а также осуществление с ними следующих действий (операций): сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение. {<br>}
                    
                    Я подтверждаю, что предоставленные мной персональные данные являются точными, актуальными и достоверными, 
                    также обязуюсь своевременно информировать Оператора об изменениях в моих персональных данных по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Настоящим подтверждаю, что в случае оформления мною заказа для третьих лиц, предоставляю персональные данные с их согласия. {<br>}
                    Настоящее согласие вступает в силу с момента его предоставления, путем проставления галочки на сайте https://homereserve.ru. {<br>}
                    Согласие действует до факта достижения цели обработки или до отзыва согласия. {<br>}

                    В соответствии с положениями ч. 2 ст. 9 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных», 
                    оставляю за собой право отозвать данное согласие посредством направления такого отзыва по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Я предупрежден(а), что в случае отзыва согласия на обработку персональных данных Оператор вправе продолжить обработку 
                    персональных данных без согласия при наличии оснований, указанных в пп. 2-11 ч. 1 ст. 6, ч. 2 ст. 10 
                    Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных»`,
        },
        privacy: {
            title: 'Палітыка ў адносінах да апрацоўкі персанальных даных',
            text: `1.ОБЩИЕ ПОЛОЖЕНИЯ {<br>}

                    1.1.Настоящая Политика в отношении обработки персональных данных (далее – Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» в целях обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе, защиты прав на неприкосновенность частной жизни, личную и семейную тайну. {<br>}
                    1.2.Политика действует в отношении всех персональных данных, которые обрабатывает {legalName}, ИНН {inn} (далее – Оператор). {<br>}
                    1.3.Политика распространяется на отношения в области обработки персональных данных, возникшие у Оператора как до, так и после утверждения Политики. {<br>}
                    1.4.Во исполнение требований ч. 2 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», Политика публикуется в личном кабинете Оператора в RealtyCalendar. {<br>}

                    2.ОСНОВНЫЕ ПОНЯТИЯ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ {<br>}

                    2.1.Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных); {<br>}
                    2.2.Оператор персональных данных (оператор) – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными; {<br>}
                    2.3.Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя в том числе: {<br>}
                    2.3.1.сбор; {<br>}
                    2.3.2.запись; {<br>}
                    2.3.3.систематизацию; {<br>}
                    2.3.4.накопление; {<br>}
                    2.3.5.хранение; {<br>}
                    2.3.6.уточнение (обновление, изменение); {<br>}
                    2.3.7.извлечение; {<br>}
                    2.3.8.использование; {<br>}
                    2.3.9.передачу (распространение, предоставление, доступ); {<br>}
                    2.3.10.обезличивание; {<br>}
                    2.3.11.блокирование; {<br>}
                    2.3.12.удаление; {<br>}
                    2.3.13.уничтожение. {<br>}
                    2.4.Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники; {<br>}
                    2.5.Распространение персональных данных – действия, направленные на раскрытие персональных данных неопределенному кругу лиц; {<br>}
                    2.6.Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц; {<br>}
                    2.7.Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных); {<br>}
                    2.8.Уничтожение персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных; {<br>}
                    2.9.Обезличивание персональных данных – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных; {<br>}
                    2.10.Информационная система персональных данных – совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств; {<br>}
                    2.11.Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу. {<br>}

                    3.ОСНОВНЫЕ ПРАВА И ОБЯЗАННОСТИ ОПЕРАТОРА {<br>}

                    3.1.Оператор имеет право: {<br>}
                    3.1.1.самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или другими федеральными законами; {<br>}
                    3.1.2.поручить обработку персональных данных другому лицу с согласия субъекта персональных данных, если иное не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора. Лицо, осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать принципы и правила обработки персональных данных, предусмотренные Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.1.3.в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Федеральном законе от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}
                    3.2. Оператор обязан: {<br>}
                    3.2.1.организовывать обработку персональных данных в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.2.отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.3.сообщать в уполномоченный орган по защите прав субъектов персональных данных (Федеральную службу по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор)) по запросу этого органа необходимую информацию в течение 10 (десяти) рабочих дней с даты получения такого запроса. {<br>}

                    4.ОСНОВНЫЕ ПРАВА СУБЪЕКТА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    4.1.Субъект персональных данных имеет право: {<br>}
                    4.1.1.получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    4.1.2.требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав; {<br>}
                    4.1.3.выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг; {<br>}
                    4.1.4.обжаловать в административном или судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных. {<br>}
                    4.2. Контроль за исполнением требований настоящей Политики осуществляется Оператором или уполномоченным лицом, ответственным за организацию обработки персональных данных у Оператора. {<br>}
                    4.3. Ответственность за нарушение требований законодательства Российской Федерации и локальных нормативных актов Оператора в сфере обработки и защиты персональных данных определяется в соответствии с законодательством Российской Федерации. {<br>}

                    5.ЦЕЛИ СБОРА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    5.1.Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных. {<br>}
                    5.2.Обработке подлежат только персональные данные, которые отвечают целям их обработки. {<br>}
                    5.3.Обработка Оператором персональных данных осуществляется в следующих целях: {<br>}
                    5.3.1.обеспечение соблюдения Конституции Российской Федерации, федеральных законов и иных нормативных правовых актов Российской Федерации; {<br>}
                    5.3.2.осуществление деятельности Оператора; {<br>}
                    5.3.3.ведение делопроизводства; {<br>}
                    5.3.4.заполнение и передача в органы исполнительной власти и иные уполномоченные организации требуемых форм отчетности; {<br>}
                    5.3.5.осуществление гражданско-правовых отношений; {<br>}
                    5.3.6.ведение бухгалтерского учета. {<br>}

                    6.ОБЪЕМ И КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ, КАТЕГОРИИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    6.1.Оператор может обрабатывать персональные данные следующих категорий субъектов персональных данных. {<br>}
                    6.1.1.Клиенты и контрагенты Оператора (физические лица): {<br>}
                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол; {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}
                    6.2.Обработка Оператором биометрических персональных данных (сведений, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность) не осуществляется. {<br>}
                    6.3.Оператором не осуществляется обработка специальных категорий персональных данных, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни, за исключением случаев, предусмотренных законодательством РФ. {<br>}

                    7.ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    7.1.Обработка персональных данных осуществляется Оператором в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.2.Обработка персональных данных осуществляется с согласия субъектов персональных данных на обработку их персональных данных, а также без такового в случаях, предусмотренных законодательством Российской Федерации. {<br>}
                    7.3.Оператор осуществляет как автоматизированную, так и неавтоматизированную обработку персональных данных. {<br>}
                    7.4.К обработке персональных данных допускаются работники Оператора, в должностные обязанности которых входит обработка персональных данных. {<br>}
                    7.5.Обработка персональных данных осуществляется путем: {<br>}
                    7.5.1.получения персональных данных в устной и письменной форме непосредственно от субъектов персональных данных; {<br>}
                    7.5.2.получения персональных данных из общедоступных источников; {<br>}
                    7.5.3.внесения персональных данных в журналы, реестры и информационные системы Оператора; {<br>}
                    7.5.4.использования иных способов обработки персональных данных. {<br>}
                    7.6.Не допускается раскрытие третьим лицам и распространение персональных данных без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом. Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения, оформляется отдельно от иных согласий субъекта персональных данных на обработку его персональных данных. {<br>}
                    Требования к содержанию согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения, утверждены Приказом Роскомнадзора от 24.02.2021 г. № 18 (а в случае его отмены в последующем – в заменяющем его нормативно-правовом акте). {<br>}
                    7.7.Передача персональных данных органам дознания и следствия, в Федеральную налоговую службу, Социальный фонд Российской Федерации и другие уполномоченные органы исполнительной власти и организации осуществляется в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.8.Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, распространения и других несанкционированных действий, в том числе: {<br>}
                    - определяет угрозы безопасности персональных данных при их обработке; {<br>}
                    - принимает локальные нормативные акты и иные документы, регулирующие отношения в сфере обработки и защиты персональных данных; {<br>}
                    - назначает лиц, ответственных за обеспечение безопасности персональных данных в структурных подразделениях и информационных системах Оператора; {<br>}
                    - создает необходимые условия для работы с персональными данными; {<br>}
                    - организует учет документов, содержащих персональные данные; {<br>}
                    - организует работу с информационными системами, в которых обрабатываются персональные данные; {<br>}
                    - хранит персональные данные в условиях, при которых обеспечивается их сохранность и исключается неправомерный доступ к ним; {<br>}
                    - организует обучение работников Оператора, осуществляющих обработку персональных данных. {<br>}
                    7.9.Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором. {<br>}
                    7.10.При сборе персональных данных, в том числе посредством информационно-телекоммуникационной сети «Интернет», запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся за пределами территории Российской Федерации, не допускаются, за исключением случаев, указанных в пунктах 2, 3, 4, 8 части 1 статьи 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}

                    8.АКТУАЛИЗАЦИЯ, ИСПРАВЛЕНИЕ, УДАЛЕНИЕ И УНИЧТОЖЕНИЕ ПЕРСОНАЛЬНЫХ ДАННЫХ, ОТВЕТЫ НА ЗАПРОСЫ СУБЪЕКТОВ НА ДОСТУП К ПЕРСОНАЛЬНЫМ ДАННЫМ {<br>}

                    8.1.Подтверждение факта обработки персональных данных Оператором, правовые основания и цели обработки персональных данных, а также иные сведения, указанные в ч. 7 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», предоставляются Оператором субъекту персональных данных или его представителю при обращении либо при получении запроса субъекта персональных данных или его представителя по адресу электронной почты: {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}
                    В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. {<br>}
                    Запрос должен содержать: {<br>}
                    - номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе; {<br>}
                    - сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных Оператором; {<br>}
                    - подпись субъекта персональных данных или его представителя. {<br>}
                    Запрос может быть направлен в форме электронного документа и подписан электронной подписью в соответствии с законодательством Российской Федерации. {<br>}
                    Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» все необходимые сведения или субъект не обладает правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ. {<br>}
                    Право субъекта персональных данных на доступ к его персональным данным может быть ограничено в соответствии с ч. 8 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», в том числе, если доступ субъекта персональных данных к его персональным данным нарушает права и законные интересы третьих лиц. {<br>}
                    8.2.В случае выявления неточных персональных данных при обращении субъекта персональных данных или его представителя либо по их запросу или по запросу Роскомнадзора Оператор осуществляет блокирование персональных данных, относящихся к этому субъекту персональных данных, с момента такого обращения или получения указанного запроса на период проверки, если блокирование персональных данных не нарушает права и законные интересы субъекта персональных данных или третьих лиц. {<br>}
                    В случае подтверждения факта неточности персональных данных Оператор на основании сведений, представленных субъектом персональных данных или его представителем либо Роскомнадзором, или иных необходимых документов уточняет персональные данные в течение семи рабочих дней со дня представления таких сведений и снимает блокирование персональных данных. {<br>}
                    8.3.При достижении целей обработки персональных данных, а также в случае отзыва субъектом персональных данных согласия на их обработку персональные данные подлежат уничтожению, если: {<br>}
                    - иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем, по которому является субъект персональных данных; {<br>}
                    - Оператор не вправе осуществлять обработку без согласия субъекта персональных данных на основаниях, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или иными федеральными законами; {<br>}
                    - иное не предусмотрено другим соглашением между Оператором и субъектом персональных данных. {<br>}

                    9.ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ {<br>}

                    9.1.Политика вступает в силу с момента утверждения Оператором и действует бессрочно. {<br>}
                    9.2.Внесение изменений, дополнение или отмена Политики производится на основании принятия Оператором соответствующего решения. {<br>}`,
        },
        booking: {
            main: {
                title: 'Правілы браніравання',
            },
            another: {
                title: 'Іншыя правілы браніравання',
            },
            refund: {
                title: 'Правілы вяртання перадаплаты',
            },
        },
        residence: {
            title: 'Правілы пражывання',
        },
        foreign_agreement: {
            title: 'Умовы браніравання, правілы пражывання і палітыка прыватнасці',
        },
    },
    hotels: {
        map: {
            close_list: 'Закрыць спіс',
        },
    },
    apartment: {
        arrival_departure_text: 'Заезд з {in_start} да {in_end}, выезд з {out_start} да {out_end}',
    },
    payment: {
        info: {
            error: {
                title: 'Спасылка састарэла',
                description: 'Калі ласка, звярніцеся да вашага менеджара:',
                agreement_required: 'Неабходна пагадзіцца з умовамі аферты',
            },
            check_in: 'Заезд',
            check_out: 'Выезд',
            amount: 'Агульны кошт',
            paid_amount: 'Аплачана',
            amount_left: 'Сума да аплаты',
            time_from: 'з {from}',
            time_to: 'да {to}',
        },
        status: {
            success: 'Аплачана',
            not_paid: 'Пражыванне не аплачана',
        },
    },
    gallery: {
        large_photo: 'Вялікая фатаграфія',
        small_photo: 'Маленькая фатаграфія',
        more_photos: '+{count} фота',
    },
};
